module.exports = __webpack_public_path__ + "assets/img/LTC024.dd17e2cc.png";